import React from 'react';
import { css } from '@linaria/core';
import { Step } from './Step';
import { classnames } from '../../utils';
/**
 * A progress stepper component for visualising a step-based process.
 */
export const ProgressTracker = ({ steps, label, completeLabel = '✓', currentStepKey, className }) => {
    const currentIndex = steps.findIndex(({ key }) => key === currentStepKey);
    const completed = steps.filter((_, index) => index < currentIndex).map(({ key }) => key);
    return (React.createElement("ol", { className: classnames(css `
          display: flex;
          width: 100%;
          /* Hide any overflowing steps from view */
          overflow-x: hidden;
        `, className), "aria-label": label }, steps.map(({ key, ...rest }) => (React.createElement(Step, { key: key, isCurrent: key === currentStepKey, isComplete: completed.includes(key), completeLabel: completeLabel, ...rest })))));
};


import "../../../css/molecules/ProgressTracker/ProgressTracker.css";
